import React, { useEffect, useState } from 'react';
import { Handles, Rail, Slider, Ticks, Tracks } from 'react-compound-slider';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import { IOrderDetails } from '../../../../models/order';
import { Handle, Tick, Track } from '../../../common/slider-components';

const sliderStyle: React.CSSProperties = {
    marginTop: '15px',
    position: 'relative',
    width: '100%',
};

const railStyle: React.CSSProperties = {
    position: 'absolute',
    width: '100%',
    height: 10,
    borderRadius: 5,
    cursor: 'default',
    backgroundColor: 'lightGrey',
};

interface IPizzaTrackerProps {
    lineStatusArray: string[];
    order: IOrderDetails;
}

export const PizzaTracker = ({
    lineStatusArray,
    order,
}: //reorder
IPizzaTrackerProps) => {
    const intl = useIntl();
    const [activeTick, setActiveTick] = useState<number | undefined>(undefined);

    useEffect(() => {
        const lineStatusLower = lineStatusArray.filter((str) =>
            str.toLowerCase()
        );
        if (lineStatusLower.includes('entered')) {
            setActiveTick(0);
        }
        if (lineStatusLower.includes('booked' || 'awaiting_shipping')) {
            setActiveTick(1);
        }
        if (lineStatusArray.includes('picked' || 'picked_partial')) {
            setActiveTick(2);
        }
        if (lineStatusArray.includes('shipped' || 'fulfilled')) {
            setActiveTick(3);
        }
        if (order.orderStatus.toLowerCase() === 'delivered') {
            setActiveTick(4);
        }
    }, [order.orderStatus, activeTick]);
    const formatTicks = (d: number) => {
        let message = intl.formatMessage({
            id: 'Submitted',
            defaultMessage: 'Submitted',
        });
        if (d === 0)
            message = intl.formatMessage({
                id: 'Submitted',
                defaultMessage: 'Submitted',
            });
        if (d === 1)
            message = intl.formatMessage({
                id: 'Received',
                defaultMessage: 'Received',
            });

        if (d === 2)
            message = intl.formatMessage({
                id: 'Processing',
                defaultMessage: 'Processing',
            });
        if (d === 3)
            message = intl.formatMessage({
                id: 'Shipped',
                defaultMessage: 'Shipped',
            });
        if (d === 4)
            message = intl.formatMessage({
                id: 'Delivered',
                defaultMessage: 'Delivered',
            });
        return message;
    };

    const getStatusIdx = (status: string[], order: IOrderDetails) => {
        let num = 0;
        status.map((s) => {
            switch (s.toLowerCase()) {
                case 'entered':
                    num = 0;
                    break;
                case 'booked':
                    num = 1;
                    break;
                case 'awaiting_shipping':
                    num = 1;
                    break;
                case 'picked':
                    num = 2;
                    break;
                case 'picked_partial':
                    num = 2;
                    break;
                case 'shipped':
                    num = 3;
                    break;
                case 'fulfilled':
                    num = 3;
                    break;
                default:
                    num = 0;
            }
            return num;
        });
        if (order.orderStatus === 'Delivered') num = 4;
        return num;
    };
    return (
        <>
            {order.orderStatus !== 'Scheduled' && (
                <div className="row" style={{ paddingBottom: '40px' }}>
                    <div className="col-md-12">
                        <Slider
                            mode={1}
                            step={1}
                            domain={[0, 4]}
                            disabled={true}
                            rootStyle={sliderStyle}
                            values={[getStatusIdx(lineStatusArray, order)]}
                        >
                            <div>
                                <label className="control-label">
                                    <FormattedMessage id="Status" />
                                </label>
                            </div>
                            <Rail>
                                {({ getRailProps }) => (
                                    <div
                                        style={railStyle}
                                        {...getRailProps()}
                                    />
                                )}
                            </Rail>
                            <Handles>
                                {({ handles, getHandleProps }) => (
                                    <div className="slider-handles">
                                        {handles.map((handle) => (
                                            <Handle
                                                key={handle.id}
                                                handle={handle}
                                                domain={[0, 4]}
                                                getHandleProps={getHandleProps}
                                            />
                                        ))}
                                    </div>
                                )}
                            </Handles>
                            <Tracks right={false}>
                                {({ tracks, getTrackProps }) => (
                                    <div className="slider-tracks">
                                        {tracks.map(
                                            ({ id, source, target }) => (
                                                <Track
                                                    key={id}
                                                    source={source}
                                                    target={target}
                                                    getTrackProps={
                                                        getTrackProps
                                                    }
                                                />
                                            )
                                        )}
                                    </div>
                                )}
                            </Tracks>
                            <Ticks values={[0, 1, 2, 3, 4]}>
                                {({ ticks }) => (
                                    <div className="slider-ticks">
                                        {ticks.map((tick) => (
                                            <Tick
                                                key={tick.id}
                                                format={formatTicks}
                                                tick={tick}
                                                count={ticks.length}
                                                activeTick={activeTick}
                                            />
                                        ))}
                                    </div>
                                )}
                            </Ticks>
                        </Slider>
                    </div>
                </div>
            )}
            <hr />
        </>
    );
};

export default PizzaTracker;
